export const deviceSizes = {
    desktop: {
      size: "1280px",
    // size: "100vw", 
    },
    tablet: {
      size: "768px",
    // size: "100vw", 
    },
    mobile: {
      size: "375px",
    // size: "100vw", 
    },
  };
  